import { useNavigate } from "react-router-dom";

const Integration = () => {
  const navigate = useNavigate();

  const onUploadExcelProduct = () => {
    navigate(`/uploadExcel?type=products`);
  };
  const onUploadExcelTiers = () => {
    navigate(`/uploadExcel?type=tiers`);
  };
  const onUploadExcelBrand = () => {
    navigate(`/uploadExcel?type=brands`);
  };

  const onUploadExcelFamlle = () => {
    navigate(`/uploadExcel?type=families`);
  };
  const onUploadExcelSubFamily = () => {
    navigate(`/uploadExcel?type=subFamilies`);
  };
  const onUploadExcelCat = () => {
    navigate(`/uploadExcel?type=categories`);
  };

  const onUploadExcelPS = () => {
    navigate(`/uploadExcelProduct`);
  };

    const onUploadExcelProductPS = () => {
    navigate(`/uploadExcelNewProducts`);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">Importer de nouveaux produits (Excel)</h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelProduct}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">Intégrer fournisseurs / clients (Excel)</h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelTiers}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">Importer de nouvelles marques (Excel)</h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelBrand}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">
                Importer des familles de produits (Excel)
              </h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelFamlle}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">
               Importer des sous-familles (Excel)
              </h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelSubFamily}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">
               Importer des catégories (Excel)
              </h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelCat}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">
               Mise à jour des quantités et prix (Excel)
              </h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelPS}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <div class="card  mt-3">
            <div class="card-body">
              <h5 class="card-title">
                Importer de nouveaux produits (quantité et prix) via Excel
              </h5>
              <button
                class="btn btn-dark float-right"
                onClick={onUploadExcelProductPS}
              >
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Integration;
